import React from 'react';
import { theme } from 'styles/theme';

/**
 * 그리드 하단 — 열 필터·조건부 규칙 칩
 */
export default function GridFilterStatusBar({
  chips = [],
  onRemove,
  onClearAll,
}) {
  if (!chips.length) return null;
  return (
    <div
      style={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 8px',
        border: `1px solid ${theme.colors.grid.border}`,
        borderTop: 'none',
        background: theme.colors.background.light,
        fontSize: theme.typography.fontSize.xs,
        color: theme.colors.text.primary,
        minHeight: 28,
        boxSizing: 'border-box',
      }}
    >
      <span style={{ color: theme.colors.text.secondary, flexShrink: 0 }}>필터</span>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 4,
          flex: 1,
          minWidth: 0,
        }}
      >
        {chips.map((chip) => (
          <span
            key={chip.id}
            title={chip.label}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              maxWidth: 280,
              padding: '1px 6px',
              borderRadius: theme.borderRadius.pill,
              background: theme.colors.primaryLight,
              color: theme.colors.primaryDark || theme.colors.primary,
              border: `1px solid ${theme.colors.primaryLight}`,
            }}
          >
            <span
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {chip.label}
            </span>
            <button
              type="button"
              aria-label="조건 해제"
              onClick={() => onRemove?.(chip)}
              style={{
                border: 'none',
                background: 'none',
                padding: 0,
                cursor: 'pointer',
                color: 'inherit',
                lineHeight: 1,
                fontSize: 12,
              }}
            >
              ×
            </button>
          </span>
        ))}
      </div>
      <button
        type="button"
        onClick={onClearAll}
        style={{
          flexShrink: 0,
          border: 'none',
          background: 'none',
          color: theme.colors.primary,
          cursor: 'pointer',
          padding: '0 4px',
          fontSize: 'inherit',
        }}
      >
        전체 해제
      </button>
    </div>
  );
}

export function buildFilterChips({ columnFilters, columns, rules, formatRuleChip, formatListFilterChip }) {
  const headerOf = (id) => {
    const col = (columns || []).find((c) => (c.id || c.accessorKey) === id);
    return col?.header || id;
  };
  const chips = [];
  (columnFilters || []).forEach((f) => {
    const selected = f.value?.selected;
    if (!Array.isArray(selected)) return;
    chips.push({
      id: `list:${f.id}`,
      type: 'list',
      columnId: f.id,
      label: formatListFilterChip(headerOf(f.id), selected.length),
    });
  });
  (rules || []).forEach((rule) => {
    chips.push({
      id: rule.id,
      type: 'rule',
      columnId: rule.columnId,
      label: formatRuleChip(rule),
    });
  });
  return chips;
}

